import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"hero\"><div class=\"hero-bg\"></div><div class=\"hero-vignette\"></div><div class=\"hero-content\"><p class=\"hero-eyebrow\">Ierapetra · Crete · Greece</p><h1 class=\"hero-title\"><span class=\"hero-line\">Where</span><span class=\"hero-line italic\">luxury</span><span class=\"hero-line\">meets the sea</span></h1><div class=\"hero-divider\"></div><p class=\"hero-sub\">Six private villas on the southern coast of Crete.</p><div class=\"hero-actions\"><a href=\"/our-villas\" class=\"btn btn-outline-white\">Our villas</a><a href=\"https://proistakisvillas.reserve-online.net\" class=\"btn btn-gold\" target=\"_blank\" rel=\"noopener\">Book a stay</a></div></div><div class=\"hero-scroll\"><span class=\"hero-scroll-line\"></span><span class=\"hero-scroll-label\">Scroll</span></div></section>", 1)
const _hoisted_3 = { class: "villas-section" }
const _hoisted_4 = { class: "villas-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "eyebrow" }, "Our collection", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, [
  /*#__PURE__*/_createTextVNode("Six villas,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("em", null, "one coastline")
], -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "villas-grid" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "villa-card-img" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "villa-card-overlay" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "villa-card-cta" }, "View villa →")
], -1)
const _hoisted_13 = { class: "villa-card-body" }
const _hoisted_14 = { class: "villa-card-meta" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "·", -1)
const _hoisted_16 = {
  key: 0,
  class: "sep"
}
const _hoisted_17 = {
  key: 1,
  class: "tag-beach"
}
const _hoisted_18 = { class: "villa-card-name" }
const _hoisted_19 = { class: "split-section" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "split-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/villas_photos/mystique_luxury_suite/image-3.webp",
    alt: "Waterfront villa"
  })
], -1)
const _hoisted_21 = { class: "split-body" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "eyebrow" }, "On the water's edge", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", { class: "split-title" }, [
  /*#__PURE__*/_createTextVNode("Waterfront"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("em", null, "villas")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "split-line" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "split-text" }, "Wake up to the Aegean. Several of our properties sit directly on the Cretan shore - private beach access, unobstructed sea views, and the sound of waves outside your window.", -1)
const _hoisted_26 = {
  href: "/our-villas",
  class: "text-link"
}
const _hoisted_27 = { class: "destinations-section" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "destinations-bg" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "destinations-overlay" }, null, -1)
const _hoisted_30 = { class: "destinations-content" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  class: "eyebrow",
  style: {"color":"rgba(201,169,108,0.7)"}
}, "Discover the island", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h2", { class: "destinations-title" }, [
  /*#__PURE__*/_createTextVNode("Beyond"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("em", null, "the villa")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "destinations-sub" }, "Chrissi Island. Myrtos Beach. Pelagos Seaside. The best of Crete is right outside your door.", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("a", {
  href: "/discover",
  class: "btn btn-outline-white"
}, "Discover Crete", -1)
const _hoisted_35 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "split-section reverse" }
const _hoisted_37 = { class: "split-body" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "eyebrow" }, "A family tradition", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h2", { class: "split-title" }, [
  /*#__PURE__*/_createTextVNode("Explore our"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("em", null, "collection")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "split-line" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "split-text" }, "Accommodation crafted for those who want to combine genuine Cretan warmth with one of the most extraordinary coastlines in the world. Not a hotel. Not a resort. A home.", -1)
const _hoisted_42 = {
  href: "/our-villas",
  class: "text-link"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "split-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/villas_photos/villa_proistakis/image-1.webp",
    alt: "Villa Proistakis"
  })
], -1)
const _hoisted_44 = { class: "cta-section" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"cta-inner\"><span class=\"eyebrow\" style=\"text-align:center;display:block;\">Get in touch</span><h2 class=\"cta-title\">Ready to plan<br><em>your stay?</em></h2><p class=\"cta-sub\">Talk to the host directly - we&#39;ll help you find the right villa for the right moment.</p><div class=\"cta-actions\"><a href=\"/contact\" class=\"btn btn-gold\">Contact us</a><a href=\"https://proistakisvillas.reserve-online.net\" class=\"btn btn-outline-gold\" target=\"_blank\" rel=\"noopener\">Book online</a></div></div>", 1)
const _hoisted_46 = [
  _hoisted_45
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_reveal = _resolveDirective("reveal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7)), [
        [_directive_reveal]
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.villas, (villa, i) => {
          return _withDirectives((_openBlock(), _createElementBlock("a", {
            key: villa.name,
            href: `/villa/${villa.name}`,
            class: _normalizeClass(["villa-card", { featured: i === 0 }])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: `/villas_photos/${villa.name}/image-${villa.preview_image}.webp`,
                alt: villa.label
              }, null, 8, _hoisted_11),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(villa.info.bedrooms) + " bed", 1),
                _hoisted_15,
                _createElementVNode("span", null, _toDisplayString(villa.info.bathrooms) + " bath", 1),
                (villa.info.beachfront)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "·"))
                  : _createCommentVNode("", true),
                (villa.info.beachfront)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Beachfront"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h3", _hoisted_18, _toDisplayString(villa.label), 1)
            ])
          ], 10, _hoisted_9)), [
            [_directive_reveal, { delay: i * 80 }]
          ])
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _hoisted_20,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _hoisted_24,
        _hoisted_25,
        _createElementVNode("a", _hoisted_26, [
          _createTextVNode("Explore all villas "),
          _createVNode(_component_font_awesome_icon, { icon: "arrow-right" })
        ])
      ])), [
        [_directive_reveal]
      ])
    ]),
    _createElementVNode("section", _hoisted_27, [
      _hoisted_28,
      _hoisted_29,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_35)), [
        [_directive_reveal]
      ])
    ]),
    _createElementVNode("section", _hoisted_36, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_37, [
        _hoisted_38,
        _hoisted_39,
        _hoisted_40,
        _hoisted_41,
        _createElementVNode("a", _hoisted_42, [
          _createTextVNode("Browse the collection "),
          _createVNode(_component_font_awesome_icon, { icon: "arrow-right" })
        ])
      ])), [
        [_directive_reveal]
      ]),
      _hoisted_43
    ]),
    _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_44, _hoisted_46)), [
      [_directive_reveal]
    ])
  ]))
}